<template>
  <v-container class="vh-footer bg-gray ps-re lynn-mobile lynn-web" fluid>
    <v-container class="pd0">
      <div class="tabs-box">
        <ul class="tab-menu">
          <li v-bind:class="{ active: openTab === 0 }">
            <a href="#n" @click="openTab = 0">분양단지</a>
          </li>
          <li v-bind:class="{ active: openTab === 1 }">
            <a href="#n" @click="openTab = 1">공사단지</a>
          </li>
          <li v-bind:class="{ active: openTab === 2 }">
            <a href="#n" @click="openTab = 2">입주단지</a>
          </li>
        </ul>
      </div>
      <div class="tab-contents">
        <div v-if="openTab == 0">
          <VillageInfoList
            :code="code"
            :data="parcellList"
            :isLoading="isLoading"
          />
        </div>
        <div v-if="openTab == 1">
          <VillageInfoList
            :code="code"
            :data="constructionList"
            :isLoading="isLoading"
          />
        </div>
        <div v-if="openTab == 2">
          <VillageInfoList
            :code="code"
            :data="libingList"
            :isLoading="isLoading"
          />
        </div>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import VillageInfoList from "@/components/VillageInfo/VillageInfoList"; // 분양단지
import { getVillageInfoList } from "@/api/index";

export default {
  components: {
    VillageInfoList,
  },
  name: "VillageInfoGird",
  data() {
    return {
      openTab: 0,
      isLoading: true,
      parcellList: [],
      constructionList: [],
      libingList: [],
    };
  },
  watch: {
    navTabIndex() {
      if (this.navTabIndex != null) {
        this.openTab = this.navTabIndex;
      }
    },
  },
  computed: {
    navTabIndex() {
      return this.$store.state.navTabIndex;
    },
    user() {
      return this.$store.getters.getUser;
    },
    code() {
      /*  
            PARCELLING: 분양중
            PARCELLING_EXPECTED: 분양예정
            CONSTRUCTION: 공사단지
            LIVING: 입주단지
        */
      return { 0: "PARCELLING", 1: "CONSTRUCTION", 2: "LIVING" }[this.openTab];
    },

    //     fillterd_villageList() {
    //       let temp = this.villageList.filter((village) => {
    //         if (this.code == "PARCELLING") {
    //           return village.is_selling_now;
    //         } else {
    //           return village.status_code_code.includes(this.code);
    //         }
    //       });
    //
    //       if (this.openTab == 1) {
    //         temp = this.sortByKey(temp, "move_in_date", true);
    //       }
    //
    //       return temp;
    //     },
  },
  methods: {
    getVillageList() {
      getVillageInfoList("mode=PARCELLING").then((res) => {
        this.parcellList = res.data;
        this.isLoading = false;
        console.log(this.parcellList);
      });
      getVillageInfoList("mode=CONSTRUCTION").then((res) => {
        this.constructionList = res.data;
      });
      getVillageInfoList("mode=LIVING").then((res) => {
        this.libingList = res.data;
      });
    },
    sortByKey(arr, key, reverse = false) {
      return arr.sort(function(a, b) {
        var keyA = a[key],
          keyB = b[key];
        if (reverse) {
          if (keyA < keyB) return 1;
          if (keyA > keyB) return -1;
        } else {
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
        }

        return 0;
      });
    },
  },
  created() {
    if (this.$route.params.tabIndex != null) {
      this.openTab = this.$route.params.tabIndex;
    }

    this.getVillageList();

    if (this.user) {
      this.$store.dispatch("GET_INTERESTED_LIST");
    }
  },
};
</script>
